<template>
    <div>
        <div class="kgr-inputAddon">
            <kgr-input
                class="kgr-inputAddon__input"
                type="text"
                :value="convertedValue"
                :is-invalid="isInvalid"
                :max-length="maxLength"
                @blur="blur"
            />
            <div class="kgr-inputAddon__addon">
                €
            </div>
        </div>
        <div
            v-if="isInvalid"
            class="kgr-color kgr-color--error"
        >
            {{ $t('Ungültiges Format') }}
        </div>
    </div>
</template>

<script>
import Input from './Input';

export default {
    components: {
        'kgr-input': Input,
    },
    props: {
        value: {
            type: Number,
            required: false,
            default: 0,
        },
        maxLength: {
            type: Number,
            required: false,
            default: 10,
        },
    },
    data() {
        return {
            isInvalid: false,
            invalidValue: null,
        }
    },
    computed: {
        convertedValue() {
            if (null !== this.invalidValue) {
                return this.invalidValue;
            }
            return this.convertFloatToMoney(this.value);
        }
    },
    methods: {
        blur(value) {
            let formerState = this.isInvalid;
            value = value.trim();
            this.isInvalid = this.validate(value) === false;
            if (this.isInvalid === false) {
                this.invalidValue = null;
                value = Number(value.replace(',', '') * this.getMultiplier(value));
                this.$emit('input', value);
                this.$nextTick(() => {
                    this.$emit('post-input', value);
                });
                if (formerState === true) {
                    this.$emit('error', false);
                }
            } else {
                this.invalidValue = value;
                if (formerState === false) {
                    this.$emit('error', true);
                }
            }
        },
        convertFloatToMoney(amount) {
            return (amount / 100).toFixed(2).toString().replace('.', ',');
        },
        validate(money) {
            let regex = RegExp(/^[0-9]\d*(?:,\d{0,2})?$/);
            return regex.test(money);
        },
        getMultiplier(money) {
            let decimals = this.countDecimals(money);
            return decimals === 0 ? 100 : (decimals === 1 ? 10 : 1);
        },
        countDecimals(money) {
            let index = money.indexOf(',');
            if (index === -1) {
                return 0;
            }
            return money.substring(index+1).length;
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
